import React from 'react';
import { IconProps } from './IconTypes';

const DeepSeekLogo: React.FC<IconProps> = ({
  size = 16,
  color = "currentColor",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M82,30 C72,28 60,32 50,42 C42,50 32,52 22,48 C18,46 14,48 14,52 C14,58 20,66 30,70 C44,76 60,76 72,68 C82,62 88,52 88,42 C88,36 86,32 82,30 Z M76,42 C73,42 71,44 71,47 C71,50 73,52 76,52 C79,52 81,50 81,47 C81,44 79,42 76,42 Z M14,52 C12,56 12,62 14,66 C18,72 24,76 30,78 L32,84 L42,82 L40,76 C36,74 32,70 30,66" />
    </svg>
  );
};

export default DeepSeekLogo;
